export default __webpack_public_path__ + "static/media/ic-sm-harvesting-1.f821d564.svg";